// @ts-nocheck
import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAdminAuth } from '@/auth/AuthProvider';
import AuthShell, {
  AuthHeaderSwap,
  authInput,
  authLabel,
  authPrimaryButton,
  authErrorBanner,
  authLink,
} from '@/components/Auth/AuthShell';

const ForgotPasswordPage = () => {
  const { forgotPassword } = useAdminAuth();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [sent, setSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    setIsSubmitting(true);
    try {
      await forgotPassword(email.trim());
      setSent(true); // always success (server doesn't reveal which emails exist)
    } catch (err: any) {
      setErrorMessage((err && err.message) || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell
      headerAction={<AuthHeaderSwap to="/sign-in" label="Sign in" />}
      title={<>Reset <span className="text-ploy-accent-primary-500">password</span></>}
      subtitle="We'll email you a link to set a new password."
    >
      {sent ? (
        <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-4 text-sm text-emerald-800">
          If an account exists for <strong>{email}</strong>, a reset link is on its way. Check your inbox.
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          {errorMessage && <div className={authErrorBanner}>{errorMessage}</div>}
          <label className={authLabel}>Email</label>
          <input
            type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className={authInput}
            placeholder="jordan@example.com"
          />
          <button type="submit" disabled={!email.trim() || isSubmitting} className={`${authPrimaryButton} mt-6`}>
            {isSubmitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
      <p className="mt-5 text-center text-xs text-ploy-neutral-inverse-600">
        <Link to="/sign-in" className={authLink}>Back to sign in</Link>
      </p>
    </AuthShell>
  );
};

export default ForgotPasswordPage;
